export default __webpack_public_path__ + "../img/079e99e7588e25db5b0ad3ab76300f74.png";